import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setSearchField, requestRobots } from '../actions';

import CardList from '../components/cardlist';
import SearchBox from '../components/searchbox';
import Scroll from '../components/scroll';
import ErrorBoundry from '../components/errorboundry';

import '../containers/app.css'

const mapStateToProps = (state) => {
  return {
    searchField: state.searchRobots.searchField,
    robots: state.requestRobots.robots,
    isPending: state.requestRobots.isPending
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSearchChange: (event) => dispatch(setSearchField(event.target.value)),
    onRequestRobots: () => dispatch(requestRobots())
  }
}

class App extends Component {
	
	componentDidMount() {
		this.props.onRequestRobots();
	}
	
	render() {
		const { robots, searchField, onSearchChange, isPending } = this.props;
		const filteredRobots = robots.filter(robot => {
			return robot.name.toLowerCase().includes(searchField.toLowerCase());
		})
		
		return (
				<div className='tc'>
				<h1 className="f1">RoboFriends</h1>
				<SearchBox searchChange={onSearchChange}/>
				<Scroll>
					{ isPending ? <h1>Loading</h1> :
					<ErrorBoundry>
						<CardList robots={filteredRobots} />
					</ErrorBoundry>
				}
				</Scroll>
				</div>
			);
		}
	}

export default connect(mapStateToProps, mapDispatchToProps)(App)